module.exports = __webpack_public_path__ + "img/via.963fdb5e.svg";